import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('common', [
      'openSharePanel',
    ]),
    ...mapActions('discovery', [
      'markAsShared',
    ]),
    share(item) {
      this.markAsShared(item.docId);
      this.openSharePanel(item);
    },
  },
};
